import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-realTime",
  "use": "icon-realTime-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-realTime\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 0h1024v1024H0V0z m471.578947 215.578947v646.736842h80.842106V215.578947h-80.842106z m-242.526315 404.210527v242.526315h80.842105v-242.526315h-80.842105z m485.052631-215.578948v458.105263h80.842105V404.210526h-80.842105z\" p-id=\"130391\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol